export default __webpack_public_path__ + "static/target2-min-46e66c20da1ad75d6b06be50959bb67b.png";